._1rvpg2m0 {
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 1;
  color: var(--_1qu8za27);
}
._1rvpg2m1._1rvpg2m1 {
  color: var(--_1qu8za27);
}
._1rvpg2m2 {
  width: 16px;
  height: 16px;
}
._1rvpg2m2 svg {
  width: 12px;
  height: 12px;
}
._1rvpg2m3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: var(--_1qu8za2d);
}
._1rvpg2m4 {
  margin-top: 6px;
  gap: 4px;
  padding: 6px 8px;
}
._1rvpg2m5 {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--_1qu8za27);
}
._1rvpg2m6 {
  font-weight: 400;
  gap: 2px;
}
._1rvpg2m7 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--_1qu8za23);
}
._1rvpg2m8 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}